import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import { setsalontype } from "../../actions/setsalontypeaction";
import FormPrompt from "../DailogBoxes/formprompt";
import AddSalonType from "./addsalontype";
import AlertDialogBox from "../DailogBoxes/alertdailogbox";
import ConfirmDialogBox from "../DailogBoxes/confirmdailogbox";
import ErorrDialogBox from "../DailogBoxes/errordaologbox";
import Service from "../../Service/firebase";

import "./salontypelist.css";

const SalontypeList = (props) => {
  const [searchText, setSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [limit, setLimit] = useState(10);
  const [isLoadMoreData, setIsLoadMoreData] = useState(false);
  const [isCloseBtnAppear, setIsCloseBtnAppear] = useState(true);
  const [isDeleting, setIsDeleting] = useState(false);
  const [totalNumOfSalonType, setTotalNumOfSalonType] = useState(null);
  const [noMoreDataText, setNoMoreDataText] = useState("");
  const [openFormDailog, setOpenFormDailog] = useState(false);
  const [openAlertDailog, setOpenAlertDailog] = useState(false);
  const [openErrorDailog, setOpenErrorDailog] = useState(false);
  const [openConfirmDailog, setOpenConfirmDailog] = useState(false);
  const [salonTypeList, setSalonTypeList] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [isSearchDataShow, setIsSearchDataShow] = useState(false);
  const [selectedSalonTypeName, setSelectedSalonTypeName] = useState("");
  const [selectedSalonTypeId, setSelectedSalonTypeId] = useState("");

  useEffect(() => {
    let isSubscribed = true;
    if (isSubscribed) {
      onSetTotalNumOfSalonType();
      onFetchData(limit);
    }
    return () => {
      isSubscribed = false;
    };
  }, []);

  const showMore = () => {
    if (limit <= totalNumOfSalonType) {
      const limit = limit + 10;
      setLimit(limit);
      onFetchData(limit);
    } else {
      setNoMoreDataText("No MoreSalonType");
    }
  };
  const onSetTotalNumOfSalonType = async () => {
    setIsLoading(true);
    const res = await Service.getTotalNumOfPerson("salonType");
    if (res === "error") {
      console.log("error");
      setIsLoading(false);
    } else {
      setTotalNumOfSalonType(res);
      setIsLoading(false);
    }
  };

  const onFetchData = async (limit) => {
    setIsLoadMoreData(true);
    const fetchedDataList = await Service.getData("salonType", limit);

    if (fetchedDataList.length !== 0) {
      setSalonTypeList(fetchedDataList);
      setIsLoadMoreData(false);
      setIsLoading(false);
    } else {
      setSalonTypeList(fetchedDataList);
      setIsLoadMoreData(false);
      setIsLoading(false);
    }
  };

  const handleOnDelete = (salonTypename, id) => {
    setSelectedSalonTypeName(salonTypename);
    setSelectedSalonTypeId(id);
    setOpenConfirmDailog(true);
  };
  const deleteData = async () => {
    setIsDeleting(true);
    const res = await Service.deleteData("salonType", selectedSalonTypeId);
    if (res === "success") {
      setIsDeleting(false);
      setOpenConfirmDailog(false);
      window.location.reload(false);
    } else {
      setIsDeleting(false);
      handleErrorDailog();
    }
  };
  const handleSearch = async () => {
    if (searchText === "" || null) {
      window.location.reload(false);
    } else {
      setIsSearching(true);
      setIsSearchDataShow(true);

      const searchTextNew = searchText?.toLowerCase().replace(/\s/g, "");

      const resultSalonTypeList = await Service.getSearchRes(
        "salonType",
        searchTextNew
      );
      if (resultSalonTypeList === "error") {
        setIsSearching(false);
        setOpenErrorDailog(true);
      } else {
        setSalonTypeList(resultSalonTypeList);
        setIsSearching(false);
      }
    }
  };

  const handleSuccessDailog = () => {
    setOpenFormDailog(false);
    setOpenAlertDailog(true);
  };
  const handleErrorDailog = () => {
    setOpenFormDailog(false);
    setOpenConfirmDailog(false);
    setOpenErrorDailog(true);
  };
  const closeFormDailog = () => {
    setOpenFormDailog(false);
  };
  const closeAlertDailog = () => {
    setOpenAlertDailog(false);
    window.location.reload(false);
  };
  const closeErrorDailog = () => {
    setOpenAlertDailog(false);
  };
  const closeConfirmDailog = () => {
    setOpenConfirmDailog(false);
  };
  const setCloseBtnAppear = () => {
    setIsCloseBtnAppear(false);
  };

  let count = 0;
  return isLoading ? (
    <div className="salonTypeListPage">
      <i className="fas fa-spinner fa-pulse fa-2x "></i>
    </div>
  ) : (
    <div className="salonTypeListPage">
      <div className="mainSection">
        <ConfirmDialogBox
          openDailog={openConfirmDailog}
          onSetOpenDailog={closeConfirmDailog}
          handleConfirmOkBtn={deleteData}
          isLoading={isDeleting}
          title="Delete"
          des={
            "Are you sure to delete " + selectedSalonTypeName + " " + "details"
          }
        ></ConfirmDialogBox>
        <AlertDialogBox
          openDailog={openAlertDailog}
          onSetOpenDailog={closeAlertDailog}
          title="Added"
          des="New Salontype has been added sccessfully"
        ></AlertDialogBox>
        <ErorrDialogBox
          openDailog={openErrorDailog}
          onSetOpenDailog={closeErrorDailog}
          title="Error"
          des="Something went wrong. Try again"
        ></ErorrDialogBox>

        <FormPrompt
          openDailog={openFormDailog}
          title="Add New SalonType"
          onSetOpenDailog={closeFormDailog}
          isCloseBtnAppear={isCloseBtnAppear}
        >
          <AddSalonType
            setCloseBtnAppear={setCloseBtnAppear}
            handleSuccessDailog={handleSuccessDailog}
            handleErrorDailog={handleErrorDailog}
            collectionName="salonType"
            id="salonTypeId"
          ></AddSalonType>
        </FormPrompt>

        <div className="topheader">
          <ul>
            <li>
              <i
                className="fa fa-arrow-circle-o-right fa-2x"
                aria-hidden="true"
              ></i>
            </li>
            <li>
              <h5>SalonType</h5>
            </li>
          </ul>
        </div>
        <hr />
        <div className="topSection">
          <div className="wrap">
            <ul>
              <li>
                <div className="search">
                  <input
                    type="text"
                    className="searchTerm"
                    placeholder="Search Salontype by  name"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleSearch();
                      }
                    }}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                    }}
                  />

                  <button
                    onClick={handleSearch}
                    type="submit"
                    className="searchButton"
                  >
                    <i className="fa fa-search"></i>
                  </button>
                </div>
              </li>
              <li style={{ fontSize: "12px" }}> #</li>
              <li style={{ fontSize: "12px" }}>{salonTypeList.length} </li>
            </ul>
          </div>

          <button
            type="button"
            className="btn btn-warning"
            onClick={() => {
              setOpenFormDailog(true);
            }}
          >
            + Add Salontype
          </button>
        </div>
        <table className="table table-striped">
          <thead className="thead tableHead">
            <tr>
              <th scope="col">#</th>
              <th scope="col">Icon</th>
              <th scope="col">Name</th>

              {/* <th scope="col">Option</th> */}
            </tr>
          </thead>
          {isSearching ? (
            <i className="fas fa-spinner fa-pulse fa-2x "></i>
          ) : salonTypeList.length === 0 ? (
            <tbody>
              <tr>
                <td>No salontype Found</td>
              </tr>
            </tbody>
          ) : (
            <tbody className="tableBody">
              {salonTypeList &&
                salonTypeList.map((p) => {
                  count++;
                  // let date = new Date(p.timeStamp.toDate());
                  //const createdTime = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
                  // const createdDate = `${date.getDate()}/${
                  //   date.getMonth() + 1
                  // }/${date.getFullYear()}`;

                  return (
                    <tr key={p.salonTypeId}>
                      <td className="align-middle">{count}</td>
                      <td className="align-middle">
                        {p.imgaeurl === "" ? (
                          <div className="userbg">
                            <i className="fa fa-user fa-2x"></i>
                          </div>
                        ) : (
                          <img className="image" alt="" srcSet={p.imgaeurl} />
                        )}
                      </td>
                      <td className="align-middle">{p.name}</td>

                      {/* <td className="align-middle">
                        <Link to="editsalontype">
                          <button
                            onClick={async () => {
                              const sendData = {
                                ...p,
                                collectionName: "salonType",
                                salonTypeId: p.salonTypeId,
                              };

                              console.log(p.salonTypeId);
                              props.setOnsalontype(sendData);
                            }}
                            type="button"
                            className="btn btn-success"
                          >
                            <i className="fa fa-edit" aria-hidden="true"></i>
                          </button>
                        </Link>
                        <button
                          type="button"
                          className="btn btn-danger"
                          onClick={() => {
                            handleOnDelete(p.name, p.salonTypeId);
                          }}
                        >
                          <i className="fa fa-trash" aria-hidden="true"></i>
                        </button>
                      </td> */}
                    </tr>
                  );
                })}
            </tbody>
          )}
        </table>

        <div className="loadMoreDataSection">
          {isLoadMoreData ? (
            <i className="fas fa-spinner fa-pulse fa-2x loadMoreDataSpinner"></i>
          ) : (
            <div className="noMoreDataText">{noMoreDataText}</div>
          )}
          {salonTypeList.length === 0 ? null : isSearchDataShow ? null : (
            <button
              type="button"
              className="btn btn-warning"
              onClick={() => showMore()}
            >
              Show More
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

const mapDisptachToProps = (dispatch) => {
  return {
    setOnsalontype: (p) => {
      dispatch(setsalontype(p));
    },
    // setOnReportDetails: (p) => {
    //   dispatch(setReportDetails(p));
    // },
  };
};

export default connect(null, mapDisptachToProps)(SalontypeList);
